import WorkTimeIndicator from './component'

export default WorkTimeIndicator
